import { settingsConstants } from '../_constants';

//-- get the list of banners
export function getGeneralSettings(state = {}, action) {
  switch (action.type) {
    case settingsConstants.C_SETTINGS_REQUEST:
      return {
        getSettings: false
      };

    case settingsConstants.C_SETTINGS_SUCCESS:
      //console.log("REDUCER ", action);
      return { getSettings:action.successAction};

    case settingsConstants.C_SETTINGS_FAILURE:
      return {
        getSettings: false,
      }; 

    default:
      return state
  }
}